// import { useEffect, useState } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
// import { Button } from "@/components/ui/button";
// import { CheckCircle, Home, BarChart3 } from "lucide-react";
// import axiosInstance from '@/config/axiosInstance';
// import { endpoints } from '@/config/apiEndpoints';


// const PaymentSuccess = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
  
//   // Get payment details from URL params
//   const amount = searchParams.get("amount") || "0.00";
//   const transactionId = searchParams.get("transaction_id") || "N/A";

//   useEffect(() => {
//     document.title = "Payment Successful - MyListIQ";
//   }, []);

//   const handleGoToDashboard = () => {
//     navigate("/dashboard");
//   };

//   const handleGoToHome = () => {
//     navigate("/");
//   };

//   return (
//     <div className="min-h-screen bg-background flex items-center justify-center p-4">
//       <div className="w-full max-w-md space-y-6">
//         {/* Success Icon */}
//         <div className="text-center">
//           <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-4" />
//           <h1 className="text-3xl font-bold text-foreground mb-2">Payment Successful!</h1>
//           <p className="text-muted-foreground">
//             Your payment has been processed successfully.
//           </p>
//         </div>

//         {/* Payment Details Card */}
//         <Card>
//           <CardHeader>
//             <CardTitle>Order Details</CardTitle>
//             <CardDescription>
//               Your payment information
//             </CardDescription>
//           </CardHeader>
//           <CardContent className="space-y-4">
//             <div className="flex justify-between items-center">
//               <span className="text-muted-foreground">Amount Paid:</span>
//               <span className="font-semibold text-lg">${amount}</span>
//             </div>
//             <div className="flex justify-between items-center">
//               <span className="text-muted-foreground">Transaction ID:</span>
//               <span className="font-mono text-sm">{transactionId}</span>
//             </div>
//           </CardContent>
//         </Card>

//         {/* Action Buttons */}
//         <div className="space-y-3">
//           <Button 
//             onClick={handleGoToDashboard}
//             className="w-full"
//             size="lg"
//           >
//             <BarChart3 className="w-4 h-4 mr-2" />
//             Go to Dashboard
//           </Button>
//           <Button 
//             onClick={handleGoToHome}
//             variant="outline"
//             className="w-full"
//             size="lg"
//           >
//             <Home className="w-4 h-4 mr-2" />
//             Back to Home
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// }; 

// export default PaymentSuccess;




// const PaymentSuccess = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const sessionId = searchParams.get("session_id");

//   const [loading, setLoading] = useState(true);
//   const [amount, setAmount] = useState("0.00");
//   const [transactionId, setTransactionId] = useState("N/A");
//   const [planName, setPlanName] = useState("");

//   useEffect(() => {
//     const verifyPayment = async () => {
//       if (!sessionId) {
//         navigate("/pricing");
//         return;
//       }

//       const token = localStorage.getItem("access_token");
//       try {
//         const res = await axiosInstance.get(
//           `${endpoints.verify_payment}?session_id=${sessionId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         if (res.data.success) {
//           // Save updated user
//           // localStorage.setItem("user", JSON.stringify(res.data.user));

//           //  Set amount, transaction ID, plan name
//           setAmount((res.data.amount ?? 0).toFixed(2));
//           setTransactionId(res.data.transaction_id || sessionId);
//           setPlanName(res.data.plan_name || "");
//         } else {
//           console.warn("Payment not verified yet");
//         }
//       } catch (err) {
//         console.error("Payment verification failed:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     verifyPayment();
//   }, [sessionId, navigate]);



//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <p className="text-lg text-muted-foreground">Verifying payment...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-background flex items-center justify-center p-4">
//       <div className="w-full max-w-md space-y-6">
//         {/* Success Icon */}
//         <div className="text-center">
//           <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-4" />
//           <h1 className="text-3xl font-bold text-foreground mb-2">Payment Successful!</h1>
//           <p className="text-muted-foreground">
//             Your payment has been processed successfully.
//           </p>
//         </div>

//         {/* Payment Details Card */}
//         <Card>
//           <CardHeader>
//             <CardTitle>Order Details</CardTitle>
//             <CardDescription>
//               Your payment information
//             </CardDescription>
//           </CardHeader>
//           <CardContent className="space-y-4">
//             <div className="flex justify-between items-center">
//               <span className="text-muted-foreground">Amount Paid:</span>
//               <span className="font-semibold text-lg">${amount}</span>
//             </div>
//             <div className="flex justify-between items-center">
//               <span className="text-muted-foreground">Transaction ID:</span>
//               <span className="font-mono text-sm">{transactionId}</span>
//             </div>
//             <div className="flex justify-between items-center">
//               <span className="text-muted-foreground">Plan:</span>
//               <span className="font-mono text-sm">{planName}</span>
//             </div>
//           </CardContent>
//         </Card>

//         {/* Action Buttons */}
//         <div className="space-y-3">
//           <Button 
//             onClick={() => navigate("/dashboard")}
//             className="w-full"
//             size="lg"
//           >
//             <BarChart3 className="w-4 h-4 mr-2" />
//             Go to Dashboard
//           </Button>
//           <Button 
//             onClick={() => navigate("/")}
//             variant="outline"
//             className="w-full"
//             size="lg"
//           >
//             <Home className="w-4 h-4 mr-2" />
//             Back to Home
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentSuccess;




import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, BarChart3, Home } from "lucide-react";
import axiosInstance from "@/config/axiosInstance";
import { endpoints } from "@/config/apiEndpoints";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState("0.00");
  const [transactionId, setTransactionId] = useState("N/A");
  const [planName, setPlanName] = useState("");

  useEffect(() => {
    const verifyPayment = async () => {
      if (!sessionId) {
        navigate("/pricing");
        return;
      }

      const token = localStorage.getItem("access_token");
      try {
        // Step 1: Verify payment
        const res = await axiosInstance.get(
          `${endpoints.verify_payment}?session_id=${sessionId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.success) {
          localStorage.setItem('has_plan', 'true');
          setAmount((res.data.amount ?? 0).toFixed(2));
          setTransactionId(res.data.transaction_id || sessionId);
          setPlanName(res.data.plan_name || "");

          // Step 2: Wait until backend updates plan (poll /api/me)
          let user = null;
          for (let attempt = 0; attempt < 5; attempt++) {
            const meRes = await axiosInstance.get("/api/me/", {
              headers: { Authorization: `Bearer ${token}` },
            });

            if (meRes.data?.plan) {
              user = meRes.data;
              break;
            }
            // wait 1 second and try again
            await new Promise((r) => setTimeout(r, 1000));
          }

          if (user) {
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("has_plan", "true");
            //  Now backend and localStorage are in sync
            navigate("/dashboard", { replace: true });
          } else {
            console.warn("Plan not updated yet — redirecting anyway");
            navigate("/dashboard", { replace: true });
          }
        } else {
          console.warn("Payment not verified");
        }
      } catch (err) {
        console.error("Payment verification failed:", err);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [sessionId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-lg text-muted-foreground">Verifying payment...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Success Icon */}
        <div className="text-center">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-foreground mb-2">Payment Successful!</h1>
          <p className="text-muted-foreground">
            Your payment has been processed successfully.
          </p>
        </div>

        {/* Payment Details */}
        <Card>
          <CardHeader>
            <CardTitle>Order Details</CardTitle>
            <CardDescription>Your payment information</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Amount Paid:</span>
              <span className="font-semibold text-lg">${amount}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Transaction ID:</span>
              <span className="font-mono text-sm">{transactionId}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Plan:</span>
              <span className="font-mono text-sm">{planName}</span>
            </div>
          </CardContent>
        </Card>

        <div className="space-y-3">
          <Button onClick={() => navigate("/dashboard")} className="w-full" size="lg">
            <BarChart3 className="w-4 h-4 mr-2" />
            Go to Dashboard
          </Button>
          <Button onClick={() => navigate("/")} variant="outline" className="w-full" size="lg">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
